<template>
  <a-drawer
    v-model:visible="visible"
    title="Selecciona los filtros de contactos gestionados"
    placement="right"
    width="480"
    keyboard
    :body-style="{ padding: 0 }"
  >
    <custom-scrollbar height="calc(100vh - 72px - 48px)">
      <div v-if="!!filters" class="modal__body">
        <p>Segmenta tu estrategia con datos gestionados y guardados en {{ ProductName }}.</p>

        <drawer-subtitle> Histórico de teléfonos gestionados </drawer-subtitle>
        <a-radio-group v-model:value="filters.clients[7].value" @change="handleChange">
          <a-radio :value="1" class="radio"> Todos los teléfonos del contacto </a-radio>
          <a-radio :value="2" class="radio">
            Solo teléfonos con Contacto Directo
            <a-tooltip>
              <template #title>
                Solo se llamará a los teléfonos que por lo menos una vez fueron tipificados como
                Contacto Directo.
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </a-radio>
        </a-radio-group>

        <drawer-subtitle
          tooltip="Filtra contactos que tengan al menos un teléfono con la tipificación seleccionada del último mes."
        >
          Mejor tipificación
        </drawer-subtitle>
        <a-form layout="vertical">
          <client-filters-input
            v-if="untilGroups"
            :item="filters.clients[0].available_values"
            label="Grupos"
            @change="selectGroup"
          />

          <client-filters-input
            v-if="untilResults"
            :item="filters.clients[1].filtered_available_values"
            label="Resultado"
            @change="selectResult"
          />
          <client-filters-input
            v-if="untilMotives"
            :item="filters.clients[2].filtered_available_values"
            label="Motivo"
            @change="selectMotive"
          />
          <client-filters-input
            v-if="untilSubmotives"
            :item="filters.clients[3].filtered_available_values"
            label="Submotivo"
            @change="handleChange"
          />
        </a-form>
        <drawer-subtitle> Selecciona usuarios con contactos asignados </drawer-subtitle>
        <!-- filters.clients[4]?.values -->
        <agents-picker
          :value="agentsSelected"
          @update:value="selectAgents($event)"
          :items="filters.clients[4]?.available_values"
          @change="handleChange"
        />
        <drawer-subtitle> Fecha de última gestión de los contactos </drawer-subtitle>
        <client-filters-date
          :value="filters.clients[5]?.values"
          @update:value="filters.clients[5].values = $event"
          @change="$event && handleChange()"
        />
        <drawer-subtitle> Fechas de Promesas de pago </drawer-subtitle>
        <client-filters-date
          :value="filters.clients[6]?.values"
          @update:value="filters.clients[6].values = $event"
          @change="$event && handleChange()"
        />
      </div>
    </custom-scrollbar>
    <div class="footer">
      <div class="footer__display">
        {{ getClientsQuantityText(calculations) }}
      </div>
      <a-button class="footer__button" @click="handleCancel"> Cancelar </a-button>
      <a-button type="primary" :disabled="!hasClients" @click="handleOk"> Aceptar </a-button>
    </div>
  </a-drawer>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import AgentsPicker from "@/app/shared/components/pickers/AgentsPicker.vue";
import DrawerSubtitle from "@/app/strategies/components/drawers/DrawerSubtitle.vue";
import ClientFiltersInput from "@/app/strategies/components/drawers/ClientFiltersInput.vue";
import ClientFiltersDate from "@/app/strategies/components/drawers/ClientFiltersDate.vue";
import { TypificationDepthLevel } from "@/app/strategies/utils/enums";
import {
  fetchResultsByGroup,
  fetchMotivesByResult,
  fetchSubMotivesByMotive,
} from "@/app/strategies/services/";
import { ProductName } from "@/app/shared/utils/constants";

import { InfoCircleOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    CustomScrollbar,
    AgentsPicker,
    DrawerSubtitle,
    ClientFiltersInput,
    ClientFiltersDate,
    InfoCircleOutlined,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    isShowDrawer: {
      required: true,
      type: Boolean,
    },
    idCampaign: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      filters: null,
      TypificationDepthLevel,
      ProductName,
      agentsSelected: [],
    };
  },
  computed: {
    calculations() {
      return {
        clients: this.filters?.number_clients,
        phones: this.filters?.number_phones,
      };
    },
    numberClients() {
      return this.filters?.number_clients || 0;
    },
    hasClients() {
      return this.numberClients !== 0;
    },
    typificationDepthLevel() {
      return this.filters?.level_palette || 2;
    },
    untilGroups() {
      return this.typificationDepthLevel >= TypificationDepthLevel.untilGroups;
    },
    untilResults() {
      return this.typificationDepthLevel >= TypificationDepthLevel.untilResults;
    },
    untilMotives() {
      return this.typificationDepthLevel >= TypificationDepthLevel.untilMotives;
    },
    untilSubmotives() {
      return this.typificationDepthLevel >= TypificationDepthLevel.untilSubmotives;
    },
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
    // agentsPortfolio() {
    //   return this.$store.getters["getAgentPortfolio"];
    // },
  },
  methods: {
    getClientsQuantityText(calculations) {
      const clients = calculations.clients;
      const phones = calculations.phones;
      if (!phones) return `${clients} contactos detectados`;
      return `${clients} contactos y ${phones} teléfonos detectados`;
    },
    addTypificationsList() {
      this.filters.clients[1].filtered_available_values = [];
      this.filters.clients[2].filtered_available_values = [];
      this.filters.clients[3].filtered_available_values = [];
    },
    initDrawer() {
      const filters = this.$store.getters["getStrategyFilters"];
      this.filters = JSON.parse(JSON.stringify(filters));

      this.addTypificationsList();
    },
    handleOk() {
      this.$store.dispatch("setStrategyFiltersState", this.filters);
      this.$emit("hideDrawer");
    },
    handleCancel() {
      this.filters = null;
      this.$emit("hideDrawer");
    },
    async handleChange() {
      const calculations = await this.$store.dispatch("fetchStrategyCalcutations", this.filters);
      this.filters = { ...this.filters, ...calculations };
    },
    async handleTypificationChange() {
      const filters = await this.$store.dispatch("fetchTypificationsFilters", this.filters);
      this.setTypificationToFilters(filters.clients);
      await this.handleChange();
    },
    setTypificationToFilters(typifications) {
      const names = ["groups", "results", "motives", "submotives"];
      typifications = typifications.slice(0, 4);

      const others = this.filters.clients.filter((item) => !names.includes(item.name));
      this.filters.clients = [...typifications, ...others];
    },
    async selectGroup(value) {
      if (value.length > 0) {
        const { results: allResults } = await fetchResultsByGroup(value);
        const filterResults = this.filters.clients[1];
        const ids = allResults.map((result) => result.id);

        filterResults.filtered_available_values = filterResults.available_values.filter(
          (availableResult) => ids.includes(availableResult.id)
        );
      }
      this.filters.clients[0].values = value;
      this.handleChange();
    },
    async selectResult(value) {
      if (value.length > 0) {
        const { results: allMotives } = await fetchMotivesByResult(value);
        const filterMotives = this.filters.clients[2];
        const ids = allMotives.map((motive) => motive.id);

        filterMotives.filtered_available_values = filterMotives.available_values.filter(
          (availableMotive) => ids.includes(availableMotive.id)
        );
      }
      this.filters.clients[1].values = value;
      this.handleChange();
    },
    async selectMotive(value) {
      if (value.length > 0) {
        const { results: allSubmotives } = await fetchSubMotivesByMotive(value);
        const filterSubmotives = this.filters.clients[3];
        const ids = allSubmotives.map((submotive) => submotive.id);

        filterSubmotives.filtered_available_values = filterSubmotives.available_values.filter(
          (availableSubmotive) => ids.includes(availableSubmotive.id)
        );
      }
      this.filters.clients[2].values = value;
      this.handleChange();
    },
    selectAgents(value) {
      this.agentsSelected = value;
      this.filters.clients[4].values = value?.map((user) => user?.id);
    }
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    margin: 12px 24px

.text
  padding: 12px 24px
  margin: 0

  &--bold
    color: $gray-9
    font-weight: 600

.footer
  display: flex
  align-items: center
  justify-content: flex-end
  margin-top: 8px
  padding: 12px 16px
  border-top: $border-normal

  &__display
    width: 100%
    font-size: 12px
    color: $gray-7

  &__button
    margin-right: 12px

.ant-form-item
  margin-bottom: 4px

.radio
  display: block
  height: 28px
  line-height: 28px
  user-select: none
</style>

<style>
.isShowDrawerStrategy {
  display: none !important;
}
</style>
